var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { validateNode } from "../helpers";
/**
 * Props for this component.
 * @typedef {{
 *  children?: React.ReactNode,
 *  className?: string,
 *  columns?: number,
 *  items?: any[],
 *  listStyle?: boolean,
 *  noPadding?: boolean,
 *  size?: "tiny" | "small" | "large",
 *  type?: "ul" | "ol" | "dl",
 *  handleClick?: Function,
 *  style?: string,
 * }} ListProps
 */
/**
 * @param {ListProps} [props] Props for this component.
 * @return {JSX.Element} JSX Element
 */
const List = (_a) => {
    var { className, columns, items = [], listStyle, type, size = "small" } = _a, props = __rest(_a, ["className", "columns", "items", "listStyle", "type", "size"]);
    const colNb = columns > 3 ? "3" : columns;
    const classes = classNames("gerudo-list", `columns-${colNb}`, `${size}`, className, {
        "list-style": listStyle,
    });
    const HtmlList = type; // default is 'ul'
    const HtmlItem = type === "dl" ? "dt" : "li";
    return (React.createElement(HtmlList, { className: classes }, items.map((el, i) => {
        return (React.createElement(HtmlItem, { key: "gerudo_list__item_" + i, className: "list-item" }, validateNode(el)));
    })));
};
List.defaultProps = {
    columns: 1,
    type: "ul",
    listStyle: false,
};
List.propTypes = {
    className: PropTypes.string,
    columns: PropTypes.number,
    listStyle: PropTypes.bool,
    items: PropTypes.array,
    noPadding: PropTypes.bool,
    size: PropTypes.oneOf(["tiny", "small", "large"]),
    type: PropTypes.oneOf(["ul", "ol", "dl"]),
};
export default List;
export { List };
//# sourceMappingURL=index.js.map